import { AgentsRepository } from "repositories/AgentsRepository";
import { AgentLinesRepository } from "repositories/AgentLinesRepository";
import { ConversationsRepository } from "repositories/ConversationsRepository";
import { EventsRepository } from "repositories/EventsRepository";
import { FilesRepository } from "repositories/FilesRepository";
import { LinesRepository } from "repositories/LinesRepository";
import { QuicklyRepliesRepository } from "repositories/QuicklyRepliesRepository";
import { SyncStateRepository } from "repositories/SyncStateRepository";

const registry = new WeakMap();

export function getRepositories(db) {
  
  if (!registry.has(db)) {

    // Initialize repositories for the given database
    const repositories = [
      AgentsRepository,
      AgentLinesRepository,
      ConversationsRepository,
      EventsRepository,
      FilesRepository,
      LinesRepository,
      QuicklyRepliesRepository,
      SyncStateRepository
    ];

    registry.set(db, repositories.reduce((acc, ClassRepository) => {
      const repository = new ClassRepository(db);
      acc[repository.storeName] = repository;
      return acc;
    }, {}));
  }

  return registry.get(db);
}
